export default __webpack_public_path__ + "static/media/young-prabu.a2321984.png";